import { Option } from '@appsinti/ui-core/dropdown/interfaces/IGroupOption';

export const HOME_CAMERAS_LIMIT = 2;

export type ChangeAction =
  | { type: 'low_limit' }
  | { type: 'replace'; checkedOptions: Option[]; newOption: Option }
  | { type: 'delete'; checkedOptions: Option[] }
  | { type: 'add'; checkedOptions: Option[] };

export const resolveChangeAction = (selectedOptions: Option[], checkedOptions: Option[]): ChangeAction => {
  if (checkedOptions.length === 0) {
    return { type: 'low_limit' };
  }

  if (checkedOptions.length === HOME_CAMERAS_LIMIT + 1) {
    const selectedValues = new Set(selectedOptions.map((option) => option.value));
    const newOption = checkedOptions.find((option) => !selectedValues.has(option.value));
    if (newOption) {
      return { type: 'replace', checkedOptions, newOption };
    }
  }

  if (checkedOptions.length === selectedOptions.length - 1) {
    return { type: 'delete', checkedOptions };
  }

  return { type: 'add', checkedOptions };
};
